import { render } from "./HeroiconsSolidMinus.vue?vue&type=template&id=6397b9fe"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMinus.vue"]])

export default __exports__